const CITATION_PATTERN = / ?\[(\d{1,3})\](?!\()/g;
const FOOTNOTE_REF_PATTERN = / ?\[\^(\d{1,3})\]/g;
const FOOTNOTE_DEF_PATTERN = /^\[\^(\d{1,3})\]:.*$/gm;

const isValidCitation = (num: number, max: number): boolean =>
   Number.isFinite(num) && num >= 1 && num <= max;

/**
 * Strips inline citation markers from each line of text, collects unique
 * citation numbers per line, and appends a single grouped citation link
 * at the end of each line.  Footnote definitions are removed entirely.
 *
 * Example output for a line with [1] and [2]:
 *   "Some claim. Another claim." -> "Some claim. Another claim. [1,2](#cite-group-1,2)"
 */
export const normalizeCitationMarkup = (
   text: string,
   maxSourceNumber: number
): string => {
   const cleaned = text.replaceAll(FOOTNOTE_DEF_PATTERN, "");

   return cleaned
      .split("\n")
      .map((line) => {
         const collected = new Set<number>();

         let processed = line.replaceAll(FOOTNOTE_REF_PATTERN, (_, rawNum) => {
            const num = Number(rawNum);
            if (isValidCitation(num, maxSourceNumber)) collected.add(num);
            return "";
         });

         processed = processed.replaceAll(CITATION_PATTERN, (_, rawNum) => {
            const num = Number(rawNum);
            if (isValidCitation(num, maxSourceNumber)) collected.add(num);
            return "";
         });

         processed = processed.trimEnd();

         if (collected.size === 0) return processed;

         const nums = Array.from(collected).sort((a, b) => a - b);
         const label = nums.join(",");
         const link = `[${label}](#cite-group-${label})`;
         return processed ? `${processed} ${link}` : link;
      })
      .join("\n");
};
